import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";
import ExternalCompanyInformation from "../components/ExternalCompanyInformation";
import StructureAndComplianceSections from "../components/StructureAndComplianceSections";
import OperationsAndRiskSections from "../components/OperationsAndRiskSections";
import styles from "../Styles";

const Sections = (props) => {
    const { supplierData, noteBackgroundColor, user, downloadDate } = props;
    
    styles.sectionSeparator.backgroundColor = noteBackgroundColor;

    return (
        <View>
            <ExternalCompanyInformation
                supplierData={supplierData}
                user={user}
                downloadDate={downloadDate}
            />

            <StructureAndComplianceSections supplierData={supplierData} />
            <OperationsAndRiskSections supplierData={supplierData} />
        </View>
    );
};

export default withNamespaces()(Sections);